// Visumo customizations: user-photo page button label + progressive padding on load more

const USER_PHOTO_MORE_BTN =
  '.user-photo-page a.ecbn-selection-more-btn.ecbn-selection-page-more';
const USER_PHOTO_WIDGET = '.user-photo-page .ecbn-selection-widget';
const TOPPAGE_USERS_PHOTO_HREF = '/pages/users-photo';

function updateUserPhotoMoreButtonLabel() {
  const moreBtn = document.querySelector(USER_PHOTO_MORE_BTN);
  if (!moreBtn) return;

  const label = moreBtn.textContent.trim();
  if (label === 'More' || label === 'もっとを見る') {
    moreBtn.textContent = 'もっと見る';
  }
  moreBtn.classList.add('btn-view-all');
  // Visumo uses href="#" which jumps the page under the sticky header
  if (moreBtn.getAttribute('href') === '#') {
    moreBtn.setAttribute('href', 'javascript:void(0)');
  }
}

/** Homepage only: rewrite Visumo black もっと見る → /pages/users-photo */
function isHomePage() {
  const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  return path === '/';
}

function updateToppageUserPhotoLink() {
  if (!isHomePage()) return;

  // Prefer homepage wrapper; fallback to .vsm-slider only on home
  const root =
    document.querySelector('.toppage-user-photo') ||
    document.querySelector('.vsm-slider');
  if (!root) return;

  const buttons = root.querySelectorAll(
    'a.ecbn-selection-to-nextpage-btn, a.vsm-selection-to-nextpage-btn'
  );

  buttons.forEach((btn) => {
    if (btn.getAttribute('href') !== TOPPAGE_USERS_PHOTO_HREF) {
      btn.setAttribute('href', TOPPAGE_USERS_PHOTO_HREF);
    }
    if (!btn.dataset.usersPhotoBound) {
      btn.dataset.usersPhotoBound = 'true';
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          window.location.href = TOPPAGE_USERS_PHOTO_HREF;
        },
        true
      );
    }
  });
}

const labelObserver = new MutationObserver(function () {
  updateUserPhotoMoreButtonLabel();
  updateToppageUserPhotoLink();
});
labelObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function () {
  const style = document.createElement('style');
  style.innerHTML = `
    .ecbn-selection-snap,
    .ecbn-selection-content,
    .ecbn-selection-wrapper {
      transition: none !important;
      transition-duration: 0s !important;
    }

    .user-photo-page .ecbn-selection-snap,
    .user-photo-page .ecbn-selection-item {
      overflow-anchor: none;
    }

    .vsm-limit-height {
      height: var(--vsm-limited-height) !important;
      overflow: hidden !important;
    }

    .vsm-fade-in {
      animation: vsmFadeIn 0.4s ease-out forwards;
    }

    @keyframes vsmFadeIn {
      from { opacity: 0; transform: translateY(15px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);

  // --- USER PHOTO PAGE: padding-top via CSS var (Visumo wipes inline styles) ---
  const PADDING_TOP_STEP = 25;
  let userPhotoClickCount = 0;
  let userPhotoPageClickBound = false;

  function applyUserPhotoWrapperPadTop() {
    const page = document.querySelector('.user-photo-page');
    if (!page) return;

    const padTop = userPhotoClickCount * PADDING_TOP_STEP;
    const padBottom = Math.round(padTop / 1);
    page.style.setProperty('--user-photo-pad-top', `${padTop}px`);
    page.style.setProperty('--user-photo-pad-bottom', `${padBottom}px`);

    // Also force inline on wrapper (belt + suspenders)
    const wrapper = document.querySelector(
      '.user-photo-page .ecbn-selection-page-wrapper'
    );
    if (wrapper) {
      wrapper.style.setProperty('padding-top', `${padTop}px`, 'important');
      wrapper.style.setProperty('padding-bottom', `${padBottom}px`, 'important');
    }
  }

  function bindUserPhotoPageLoadMore() {
    if (userPhotoPageClickBound) return;
    if (!document.querySelector('.user-photo-page')) return;

    userPhotoPageClickBound = true;

    // Capture on document so we always catch the click
    document.addEventListener(
      'click',
      function (event) {
        const target =
          event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!target?.closest('.user-photo-page')) return;

        const btn = target.closest(
          'a.ecbn-selection-more-btn.ecbn-selection-page-more, a.ecbn-selection-more-btn'
        );
        if (!btn) return;

        event.preventDefault();

        // Apply padding immediately on click — do not wait for Visumo render
        userPhotoClickCount += 1;
        applyUserPhotoWrapperPadTop();
        updateUserPhotoMoreButtonLabel();

        [50, 150, 400, 800, 1500].forEach((ms) => {
          setTimeout(applyUserPhotoWrapperPadTop, ms);
        });
      },
      true
    );
  }

  bindUserPhotoPageLoadMore();

  setInterval(function () {
    if (!document.querySelector('.user-photo-page')) return;
    updateUserPhotoMoreButtonLabel();
    bindUserPhotoPageLoadMore();
    if (userPhotoClickCount > 0) applyUserPhotoWrapperPadTop();
  }, 300);

  // --- HOMEPAGE: rewrite toppage-user-photo もっと見る → /pages/users-photo ---
  updateToppageUserPhotoLink();
  setInterval(updateToppageUserPhotoLink, 300);

  // --- OTHER VISUMO GRIDS (homepage etc.): existing limit / reveal logic ---
  let isLimited = true;
  let clickCount = 1;

  setInterval(function () {
    if (document.querySelector('.user-photo-page')) return;
    // Skip limit logic for homepage slider (toppage-user-photo)
    if (document.querySelector('.toppage-user-photo')) {
      updateToppageUserPhotoLink();
    }

    const activeUl = document.querySelector('.ecbn-selection-content--active .ecbn-selection-snap');
    const loadMoreBtn = document.querySelector('.ecbn-selection-more-btn');
    if (!activeUl || !loadMoreBtn) return;

    const items = activeUl.querySelectorAll('.ecbn-selection-item');

    if (isLimited && items.length > 8) {
      items.forEach((item, index) => {
        if (index >= 8) {
          item.style.setProperty('display', 'none', 'important');
          item.classList.remove('vsm-fade-in');
        }
      });

      const ninthItemTop = items[8].style.top;
      if (ninthItemTop) {
        activeUl.style.setProperty('--vsm-limited-height', ninthItemTop);
        activeUl.classList.add('vsm-limit-height');
      }
    }

    if (!loadMoreBtn.dataset.bound) {
      loadMoreBtn.dataset.bound = 'true';

      loadMoreBtn.addEventListener('click', function () {
        isLimited = false;
        let maxItemBottom = 0;

        document
          .querySelectorAll('.ecbn-selection-content--active .ecbn-selection-item')
          .forEach((item, index) => {
            if (index >= 8) {
              item.style.removeProperty('display');
              item.classList.add('vsm-fade-in');
            }

            const topVal = parseInt(item.style.top || 0, 10);
            const itemHeight = item.offsetHeight > 0 ? item.offsetHeight : 380;
            const bottomPos = topVal + itemHeight;
            if (bottomPos > maxItemBottom) maxItemBottom = bottomPos;
          });

        const currentUl = document.querySelector(
          '.ecbn-selection-content--active .ecbn-selection-snap'
        );
        if (currentUl) {
          currentUl.classList.remove('vsm-limit-height');
          if (maxItemBottom > 0) {
            currentUl.style.setProperty('height', `${maxItemBottom}px`, 'important');
          }
        }

        const dynamicPadding = 60 + (clickCount - 1) * 25;
        const gridWrapper =
          document.querySelector('.vsm-grid') || document.querySelector('.ecbn-selection-widget');
        if (gridWrapper) {
          gridWrapper.style.setProperty('padding-bottom', `${dynamicPadding}px`, 'important');
        }

        clickCount++;
      });
    }

    document.querySelectorAll('.ecbn-selection-page-tabs--link').forEach((tab) => {
      if (tab.dataset.bound) return;
      tab.dataset.bound = 'true';
      tab.addEventListener('click', function () {
        isLimited = true;
        clickCount = 1;
        const gridWrapper =
          document.querySelector('.vsm-grid') || document.querySelector('.ecbn-selection-widget');
        if (gridWrapper) gridWrapper.style.removeProperty('padding-bottom');
      });
    });
  }, 300);
});
